import { render, staticRenderFns } from "./ReturnBox.vue?vue&type=template&id=14279063&scoped=true"
import script from "./ReturnBox.vue?vue&type=script&lang=js"
export * from "./ReturnBox.vue?vue&type=script&lang=js"
import style0 from "./ReturnBox.vue?vue&type=style&index=0&id=14279063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14279063",
  null
  
)

export default component.exports